import GalleryHeader from './GalleryHeader.vue';
import GalleryMasonry from './GalleryMasonry.vue';
import GalleryCarousel from './GalleryCarousel.vue';
import GalleriesOverview from './GalleriesOverview.vue';
import index from './index';
import moduleId from './moduleId';

class GalleryRouteHandler {
  getRoutes = ({ moduleType }) => {
    return [
      {
        path: `/${index.path}/:instance`,
        name: 'galleryOverview',
        meta: { moduleType, initiateSyncBeforeNav: true, moduleId, baseRoute: true },
        components: { default: GalleriesOverview, header: GalleryHeader },
      },
      {
        path: `/${index.path}/cards/:instance/:galleryId`,
        name: 'galleryMasonry',
        meta: {
          moduleType,
          backPath: (currentRouteParams) => {
            return `/${index.path}/${currentRouteParams.instance}`;
          },
          initiateSyncBeforeNav: false,
          moduleId,
          baseRoute: true,
          transitionName: 'slide',
        },
        components: { default: GalleryMasonry, header: GalleryHeader },
      },
      {
        path: `/${index.path}/carousel/:instance/:galleryId`,
        backPath: (currentRouteParams) => {
          return `/${index.path}/${currentRouteParams.instance}`;
        },
        name: 'galleryCarousel',
        meta: {
          moduleType,
          backPath: (currentRouteParams) => {
            return `/${index.path}/${currentRouteParams.instance}`;
          },
          initiateSyncBeforeNav: false,
          moduleId,
          baseRoute: false,
          transitionName: 'slide',
        },
        components: { default: GalleryCarousel, header: GalleryHeader },
      },
      { 
     
        path: `/${index.path}/carousel/:instance/:galleryId/:imageId`,
        name: 'oneImage',
        meta: {
          moduleType,
          backPath: (currentRouteParams) => {
            return `/${index.path}/carousel/${currentRouteParams.instance}/${currentRouteParams.galleryId}`;
          },
          initiateSyncBeforeNav: false,
          moduleId,
          baseRoute: false,
          transitionName: 'slide',
        },
        components: { default: GalleryCarousel, header: GalleryHeader },
      },
    ];
  };
}
const routeHandler = new GalleryRouteHandler();
export default routeHandler;
